import { type IntlShape, useIntl } from "react-intl";
import type { TieredPriceProductId } from "@project/common";
import { INTERNATIONALIZED_PRODUCT_LABELS } from "../../../../constants/productLabels.js";
import { useCallback } from "react";

const get = (intl: IntlShape, productId: TieredPriceProductId, what: "name" | "description") =>
  intl.formatMessage(INTERNATIONALIZED_PRODUCT_LABELS[`${productId}.${what}`]);

export const useProductNames = () => {
  const intl = useIntl();
  return useCallback((productId: TieredPriceProductId) => get(intl, productId, "name"), [intl]);
};

export const useProductDescriptions = () => {
  const intl = useIntl();
  return useCallback((productId: TieredPriceProductId) => get(intl, productId, "description"), [intl]);
};
